import * as types from '../actions/actionTypes';

const initialState = {
    login: {
        success: true,
        loading: false,
        message: '',
        data: {}
    },
    verifyLogin: {
        success: true,
        loading: false,
        message: ''
    },
    logout: {
        success: true,
        loading: false,
    },
    recoverPassword: {
        success: true,
        loading: false
    },
    resetPassword: {
        success: true,
        loading: false,
        expired: false
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.START_LOGIN:
            return Object.assign({}, state, { login: { ...initialState.login, loading: true } });
        case types.LOGIN:
            return Object.assign({}, state, { login: action.response });

        case types.START_VERIFY_LOGIN:
            return Object.assign({}, state, { verifyLogin: { ...initialState.verifyLogin, loading: true } });
        case types.VERIFY_LOGIN:
            return Object.assign({}, state, { verifyLogin: action.response });

        case types.START_LOGOUT:
            return Object.assign({}, state, { logout: { ...initialState.logout, loading: true } });
        case types.LOGOUT:
            return Object.assign({}, state, { logout: action.response });

        case types.START_RECOVER_PASSWORD:
            return Object.assign({}, state, { recoverPassword: { ...initialState.recoverPassword, loading: true } });
        case types.RECOVER_PASSWORD:
            return Object.assign({}, state, { recoverPassword: action.response });

        case types.START_RESET_PASSWORD:
            return Object.assign({}, state, { resetPassword: { ...initialState.resetPassword, loading: true } });
        case types.RESET_PASSWORD:
            return Object.assign({}, state, { resetPassword: action.response });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/AuthenticationReducer.js